module.exports = __webpack_public_path__ + "img/4_ua.35b9d0b7.webp";